// https://github.com/tc39/proposal-observable
require('../internals/define-well-known-symbol')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/esnext.symbol.observable.js
// module id = 610
// module chunks = 0